import { ENVIRONMENT_IS_DEVELOPMENT } from "./development";

export default function getTitle(subtitle?: string): string {
    const devText = ENVIRONMENT_IS_DEVELOPMENT ? '[DEV] ' : '';

    const subtext = subtitle
        ? ` - ${subtitle}`
        : '';

    const titleText = `${devText}S•P•Q•R${subtext}`;

    return titleText;
}
